/*
 * Bigens PDP tip card (T30): "Next tip" cycles the tips. Nothing rotates by itself (WCAG 2.2.2), so there is
 * no timer and nothing to pause. The tips share one grid cell; only [data-active] is visible.
 */
class BigensPdpTip extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.bigens-pdp-tip__item')];
    this.button = this.querySelector('[data-tip-next]');
    this.current = this.querySelector('[data-tip-current]');
    this.onNext = () => this.show((this.index + 1) % this.items.length);
    this.button?.addEventListener('click', this.onNext);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onNext);
  }

  get index() {
    return Math.max(0, this.items.findIndex((item) => item.hasAttribute('data-active')));
  }

  show(index) {
    this.items.forEach((item, i) => item.toggleAttribute('data-active', i === index));
    if (this.current) this.current.textContent = `${index + 1}`;
  }
}

if (!customElements.get('bigens-pdp-tip')) {
  customElements.define('bigens-pdp-tip', BigensPdpTip);
}
